require('./bootstrap');

import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import App from './components/App.vue';
import router from './router.js';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VueSweetalert2 from 'vue-sweetalert2';
import BootstrapVue from 'bootstrap-vue' ;
import Autocomplete from 'vuejs-auto-complete' ;
import QuickEdit from 'vue-quick-edit' ;
import Pagination from 'laravel-vue-pagination';
import VueFloatLabel from "vue-float-label";
import store from './store';
// import '../../public/css/table.css';
// import '../../public/css/modified_app.css';
import Permissions from './components/mixins/Permissions.vue';
import VuePageTransition from 'vue-page-transition';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import VueMomentJS from 'vue-momentjs';
import Vuex from 'vuex';
import formatNumber from '../js/components/helpers/formatNumber';
import autoLogout from '../js/components/helpers/autoLogout';
import {initialize} from './store';
import IdleVue from 'idle-vue'

Vue.use(VueMomentJS,moment);
Vue.use(VuePageTransition);
Vue.use ( BootstrapVue ) ;
Vue.use(VueSweetalert2);
Vue.use(VueFloatLabel);
Vue.use(Vuex);
Vue.mixin(formatNumber);
Vue.mixin(autoLogout);
Vue.mixin(Permissions);
Vue.component('autocomplete',Autocomplete);
Vue.component('quick-edit',QuickEdit);
Vue.component('pagination',Pagination);
Vue.component('datepicker',Datepicker);
Vue.component('v-select',vSelect);

// initialize(store, router);
import * as auth from "./components/services/auth.js";
let vDoc =  new Vue( {
    el: '#app' ,
    router ,
    store,
    render : h => h( App ),
} ) ;

document.onmousemove = function() {
    vDoc.$resetTimer();
};
document.onkeypress = function() {
    vDoc.$resetTimer();
};